import { Encoder } from '@everyboard/lib';
import { Coord } from '../../jscaip/Coord';
import { MoveCoord } from '../../jscaip/MoveCoord';
import { Orthogonal } from '../../jscaip/Orthogonal';
export class QuixoMove extends MoveCoord {
    direction;
    static encoder = Encoder.tuple([Coord.encoder, Orthogonal.encoder], (m) => [m.coord, m.direction], (fields) => new QuixoMove(fields[0].x, fields[0].y, fields[1]));
    constructor(x, y, direction) {
        super(x, y);
        this.direction = direction;
    }
    toString() {
        return 'QuixoMove(' + this.coord.x + ', ' + this.coord.y + ', ' + this.direction.toString() + ')';
    }
    equals(other) {
        if (other === this)
            return true;
        if (other.coord.equals(this.coord) === false)
            return false;
        return other.direction === this.direction;
    }
}
